import cx from 'classnames';

import { SUMMARY_DEFINITIONS } from '@xing-com/content-editor-plugin-helpers';

import { SUMMARY_TAG_NAME } from './constants';
import styles from './Summary.css';

const summaryRenderer = ({
  node: { type },
  SUMMARY_TAG = SUMMARY_TAG_NAME,
  ...attributes
}) => {
  if (type === SUMMARY_DEFINITIONS.type) {
    const {
      nodeAttributes: { children },
      renderers,
      ...restOfAttributes
    } = attributes;

    return (
      <SUMMARY_TAG {...restOfAttributes} data-editor-plugin="summary">
        {children}
      </SUMMARY_TAG>
    );
  }
};

const renderer = ({ className, ...props } = {}) =>
  summaryRenderer({
    ...props,
    className: cx(styles.summary, className),
  });

export { renderer };
